import type { EditorThemeClasses } from 'lexical'
import * as style from './style.css'

export const editorTheme: EditorThemeClasses = {
  code: style.code,
  heading: {
    h1: style.heading.h1,
    h2: style.heading.h2,
    h3: style.heading.h3,
    h4: style.heading.h4,
    h5: style.heading.h5,
  },
  image: style.image,
  link: style.link,
  list: {
    listitem: style.list.listitem,
    nested: {
      listitem: style.list.nested.listitem,
    },
    ol: style.list.ol,
    // ul: style.list.ul,
    ulDepth: [style.list.ulDepth0, style.list.ulDepth1, style.list.ulDepth2],
  },
  ltr: style.ltr,
  paragraph: style.paragraph,
  placeholder: style.placeholder,
  quote: style.quote,
  rtl: style.rtl,
  text: {
    bold: style.textBold,
    code: style.textCode,
    hashtag: style.textHashtag,
    italic: style.textItalic,
    overflowed: style.textOverflowed,
    strikethrough: style.textStrikethrough,
    underline: style.textUnderline,
    underlineStrikethrough: style.textUnderlineStrikethrough,
  },
}
